import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'ten-ticket-booking-dialog',
  standalone: true,
  imports: [MatProgressSpinnerModule, TranslateModule, MatLegacyDialogModule],
  templateUrl: './ticket-booking-dialog.component.html',
  styleUrls: ['./ticket-booking-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketBookingDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) { }
}
